"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.LoadingSpinner = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var spinner_1 = __importDefault(require("@atlaskit/spinner"));
var LoadingSpinner = function () { return ((0, jsx_runtime_1.jsx)("div", __assign({ style: {
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    } }, { children: (0, jsx_runtime_1.jsx)(spinner_1["default"], { size: "large" }, void 0) }), void 0)); };
exports.LoadingSpinner = LoadingSpinner;
//# sourceMappingURL=LoadingSpinner.js.map